import { GetStaticPaths, GetStaticProps } from 'next'
import React, { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getAllUsersSlugs } from 'app/services/Api/user'
import { listingKeys } from 'app/services/Query/listing/listing.keys'
import { listingConfig } from 'app/services/Query/listing/listing.query'
import { userKeys } from 'app/services/Query/user/user.keys'
import { userConfig } from 'app/services/Query/user/user.query'
import { NextPage } from 'app/types/decalarations/next'

import StoreLayout from '~/components/layouts/StoreLayout'
import ProductsView from '~/views/Store/ProductsView'

const StoreProductsPage: NextPage = () => <ProductsView />

StoreProductsPage.getLayout = (page: ReactElement) => (
  <StoreLayout>{page}</StoreLayout>
)

export const getStaticPaths: GetStaticPaths = async () => {
  const { slugs } = await getAllUsersSlugs()

  const paths = slugs.map((slug) => ({ params: { slug } }))

  return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const revalidate = 60
  const slug = context.params?.slug as string
  const p = context.params?.p as string

  try {
    const queryClient = new QueryClient()

    const productsKeyQuery = listingKeys.getListingsByUser({
      slug,
      page: Number(p) || 1
    })

    await queryClient.prefetchQuery(
      productsKeyQuery,
      listingConfig.getListingsByUser.request
    )

    const state =
      queryClient.getQueryState<PaginationListingModel>(productsKeyQuery)

    const hasListings =
      !!state?.data?.listings?.length && state?.data?.listings?.length > 0

    if (hasListings) {
      const userKeyQuery = userKeys.getUserBySlug(slug)

      await queryClient.prefetchQuery(
        userKeyQuery,
        userConfig.getUserBySlug.request
      )
    }

    return {
      revalidate,
      props: {
        dehydratedState: dehydrate(queryClient)
      }
    }
  } catch (error) {
    return { notFound: true, revalidate }
  }
}

export default StoreProductsPage
